import { render, staticRenderFns } from "./DmPendingNearMatchOverview.vue?vue&type=template&id=e4576102&scoped=true&"
import script from "./DmPendingNearMatchOverview.vue?vue&type=script&lang=js&"
export * from "./DmPendingNearMatchOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4576102",
  null
  
)

export default component.exports